import { ChangeDetectorRef, Component, Input, NgModule, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IconService } from './service/icon.service';
import { catchError, tap } from 'rxjs';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-system-icon',
  templateUrl: './icon.component.html',
})
export class IconComponent implements OnInit, OnChanges {
  @Input() iconName = '';
  @Input() iconSize = 24;
  @Input() iconType: 'solid' | 'outline' = 'solid';
  svgContent!: SafeHtml;
  iconSizeStyle = '';
  constructor(
    private iconService: IconService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.iconName) {
      this.loadSvg();
    }
  }

  ngOnInit() {
    this.loadSvg();
  }

  private loadSvg() {
    if (this.iconName) {
      this.iconService
        .getSvgIcon(this.iconType, this.iconName)
        .pipe(
          tap(data => {
            this.iconSizeStyle = `width: ${this.iconSize}px; height: ${this.iconSize}px;`;
            this.svgContent = data;
            this.cdr.detectChanges();
          }),
          catchError(() => {
            throw new Error('Error loading icon');
          })
        )
        .subscribe();
    }
  }
}

@NgModule({
  declarations: [IconComponent],
  exports: [IconComponent],
})
export class SystemIconComponentModule {}
